import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import classnames from 'classnames';
import metrics from 'lib/common/metrics';
import summaryTitle from 'lib/seats/summaryTitle';
import messagesForSeat from 'lib/seats/messagesForSeat';
import features from 'lib/common/features';

import Modal from 'components/Modal';
import SeatView from 'components/SeatView';
import PriceTypeExisting from 'components/PriceTypeExisting';
import PriceTypeOption from 'components/PriceTypeOption';
import InlineSeatUpsell from 'components/InlineSeatUpsell';

const SeatDetails = React.createClass({
  propTypes: {
    selectedSeat: PropTypes.object.isRequired,
    seatView: PropTypes.object,
    priceTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentLineItem: PropTypes.object,
    handleSelection: PropTypes.func.isRequired,
    handleDeselection: PropTypes.func.isRequired,
    handleRemoval: PropTypes.func.isRequired,
    upsell: PropTypes.object,
    onSelectUpsell: PropTypes.func,
    currentPodSeats: PropTypes.array,
    handlePodSelection: PropTypes.func,
    currentPodAmount: PropTypes.number
  },

  handleClose: function() {
    const shouldDeselectOnClose = this.props.currentLineItem ? false : true;
    this.props.handleDeselection(
      this.props.selectedSeat,
      shouldDeselectOnClose
    );
  },

  handleRemoval: function() {
    this.props.handleRemoval(this.props.currentLineItem);
    this.handleClose();
  },

  hasUpsell: function() {
    return !!this.props.upsell && !this.props.currentLineItem;
  },

  renderSeatUpsell: function() {
    if (this.hasUpsell()) {
      // Log Google Analytics custom event saying upsell was shown
      metrics.action(
        'Seat Upsell: Shown Upsell',
        [
          'Upsell shown from',
          this.props.upsell.referencePriceType.description,
          'to',
          this.props.upsell.seat.seatData.section_desc,
          'for performance',
          this.props.upsell.performanceId
        ].join(' ')
      );

      return (
        <div className="syos-selection__upsell">
          <InlineSeatUpsell
            upsell={this.props.upsell}
            handleSelection={this.props.onSelectUpsell}
          />
        </div>
      );
    }

    return null;
  },

  renderAvailablePrices: function() {
    if (this.props.priceTypes.length > 0) {
      return (
        <ul className="u-syos-unstyled-list">
          {this.props.priceTypes.map((priceType, idx) => {
            return (
              <li key={idx}>
                <PriceTypeOption
                  priceType={priceType}
                  handleSelection={() => {
                    this.props.handleSelection(
                      this.props.selectedSeat,
                      priceType
                    );
                  }}
                />
              </li>
            );
          })}
        </ul>
      );
    } else {
      return <p>There are currently no prices available for this seat.</p>;
    }
  },

  render: function() {
    const {
      selectedSeat,
      seatView,
      currentLineItem,
      currentPodSeats,
      podMinimum
    } = this.props;

    const messages = messagesForSeat(
      config.seatMessages,
      selectedSeat.seatData
    );

    return (
      <Modal onClose={this.handleClose}>
        <div
          className={classnames({
            'syos-selection': true,
            'has-upsell': this.hasUpsell(),
            'syos-pods': features.isEnabled('podSeats')
          })}
        >
          <div className="syos-selection__details">
            <div className="syos-seat-details">
              <h4 className="syos-seat-details__title">
                {summaryTitle(selectedSeat.seatData)}
                {features.isEnabled('podSeats') &&
                currentPodSeats &&
                !currentLineItem && (
                  <div className="pods-amount">
                    {features.getOption('podSeats', 'message')}
                  </div>
                )}
              </h4>
              {seatView &&
              seatView.image && (
                <div className="syos-seat-details__seatview">
                  <SeatView seatView={seatView} />
                </div>
              )}
              {messages.length > 0 && (
                <div className="syos-seat-details__messages">
                  {messages.map((message, key) => {
                    return <p key={key}>{message.text}</p>;
                  })}
                </div>
              )}
              <div className="syos-seat-details__pricetypes">
                {features.isEnabled('podSeats') &&
                currentPodSeats &&
                !currentLineItem && (
                  <select
                    className="pods-selection"
                    onChange={this.props.handlePodSelection}
                    value={this.props.currentPodAmount}
                  >
                    {currentPodSeats.map((item, key) => {
                      if (currentPodSeats.length - key >= podMinimum) {
                        return (
                          <option
                            key={item}
                            value={currentPodSeats.length - key}
                          >
                            Select {currentPodSeats.length - key} seats
                          </option>
                        );
                      }
                    })}
                  </select>
                )}
                {currentLineItem ? (
                  <PriceTypeExisting
                    handleRemoval={this.handleRemoval}
                    description={config.basket.existingMessage}
                  />
                ) : (
                  this.renderAvailablePrices()
                )}
              </div>
            </div>
          </div>
          {this.renderSeatUpsell()}
        </div>
      </Modal>
    );
  }
});

export default SeatDetails;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/SeatDetails.js